import { Bugsnag } from '@src/config'
import { Feature } from '@src/components/FeatureFlag'
import Unleash from '@src/config/unleash'

export const isNotificationInboxEnabled = () => {
  try {
    return Unleash.client.isEnabled(Feature.NotificationInbox)
  } catch (error: unknown) {
    Bugsnag.notify(error as string)
    return false
  }
}

export const getNotificationRefetchActions = (notificationInboxEnabled: boolean) =>
  notificationInboxEnabled ? ['fetchLive', 'fetchInboxSummary'] : ['fetch']
